var map = {
	"./index.js": "4360",
	"./modules/bind-account/index.js": "bc83",
	"./modules/home/index.js": "cf72",
	"./modules/manage-center/purchase/index.js": "f30b",
	"./modules/news/index.js": "c498",
	"./modules/order/index.js": "4652",
	"./modules/shopping-cart/distributor/index.js": "2b91",
	"./modules/shopping-cart/purchase/index.js": "3f73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1954";